import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {SelectionModel} from "@angular/cdk/collections";
import {RegistrationIdImport} from "../../../shared/interface/registration-id-import";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {
  FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN,
  FILE_TYPE_CERT_100P, FILE_TYPE_CONTRACT_WITH_EMPLOYEE,
  FILE_TYPE_DIPLOMA,
  FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA, FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU,
  IMPORT_STATUS_IN_PROGRESS
} from '../../../shared/services/dict.service';
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {AddressImportService} from "../../../shared/services/address-import.service";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {AddressImport} from "../../../shared/interface/address-import";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {DocumentAddDialogComponent} from "../../documents/document-add-dialog/document-add-dialog.component";
import {AddressImportComponent} from "../address-import/address-import.component";
import {Krk} from "../../../shared/interface/krk";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'app-all-address-import',
  templateUrl: './all-address-import.component.html',
  styleUrls: ['./all-address-import.component.scss']
})
export class AllAddressImportComponent implements  AfterViewInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  protocolOpened = false;
  readonly IMPORT_STATUS_IN_PROGRESS = IMPORT_STATUS_IN_PROGRESS;
  selection = new SelectionModel<AddressImport>(false, []);
  initialFilters: any;
  imports: AddressImport[] = [];
  displayedColumns: string[] = [
    'changeToRegistered', 'fileName',
    'createdAt', 'createdBy', 'status', 'actions'
  ];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  typeOnlyKeys: any = undefined;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private addressImportService: AddressImportService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.addressImportService.importListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<AddressImport>) => {
          this.imports = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }


  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({}, filters);
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadListData(): void {
    this.addressImportService.loadImportList(this.paginator.pageIndex, this.paginator.pageSize, this.initialFilters);
  }

  filter(): void {
    if (this.paginator.pageIndex === 0) {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value
      })]);
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value,
      })]);
    }
  }

  onImgError($event: ErrorEvent): void {
    // @ts-ignore
    $event.target.src = '/assets/avatar.png';
  }

  import(): void {
    const dialogRef = this.dialog.open(AddressImportComponent, {
      width: '55%',
      data: {},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });
  }

  delete(addressImport: AddressImport): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć import?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.addressImportService.delete(addressImport.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto import', '', {duration: 2000});
            this.loadListData();
          });
      }
    });
  }
}
